module.exports = __webpack_public_path__ + "static/media/oficinas_top_banner.2793c58a.webp";